// frontend/src/App.js (Updated routes for slug-only URLs)
import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import VideoPage from "./pages/VideoPage";
import PlaylistPage from "./pages/PlaylistPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticlePage from "./pages/ArticlePage";
import SearchPage from "./pages/SearchPage";
import QuizPage from "./pages/QuizPage";
import EventsPage from "./pages/EventsPage";
import EventPage from "./pages/EventPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import LiveEventBar from "./components/event/LiveEventBar";

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <LiveEventBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/search" element={<SearchPage />} />

        {/* Slug-only URLs */}
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/video/:slug" element={<VideoPage />} />
        <Route path="/playlist/:slug" element={<PlaylistPage />} />

        {/* Articles */}
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/article/:slug" element={<ArticlePage />} />

        {/* Quizzes */}
        <Route path="/quiz/:slug" element={<QuizPage />} />

        {/* Events */}
        <Route path="/events" element={<EventsPage />} />
        <Route path="/event/:slug" element={<EventPage />} />

        {/* Playlist with specific video */}
        <Route path="/playlist/:playlistSlug/video/:videoSlug" element={<VideoPage />} />

        <Route
          path="*"
          element={
            <div className="text-center py-20">
              <h1 className="text-2xl">Page Not Found</h1>
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
